// Значения по умолчанию
const defaultConfig = {
    type: 'date',
    debug: false,
    showDateSelector: true, // Показываем селектор выбора даты
    closeOnSelect: true, // Закрываем календарь при выборе даты кликом

    upperLimit: new Date(new Date().getFullYear() + 5, 0, 1), // Верхнее значение календаря
    lowerLimit: new Date(new Date().getFullYear() - 100, 0, 1), // Нижнее значение календаря

    // Формат дат
    dateFormat: {
        hour12: false,
        firstDay: 1, // Начало недели 0 - ВС, 1 - ПН
        dateMask: 'DD.MM.YYYY',
        dateLiteral: '.',

        timeMask: 'HH:MM',
        timeLiteral: ':',

        dateTimeLiteral: ', '
    },

    // Рабочие дни
    workDays: [0, 1, 2, 3, 4, 5, 6],

    locale: {}
};

export default class Config {
    constructor(root, opts) {
        this.config = {
            ...defaultConfig,
            ...opts
        };

        _initConfig.call(this);
        _initLocale.call(this);

        _initMasks.call(this);
    }


    get() {
        return this.config;
    }

    getMasks() {
        return this.masks;
    }
}

function _initConfig() {
    const { config } = this;

    // Конфигурация лимитов календаря
    if (config.upperLimit instanceof Date) {
        config.upperLimit = {
            date:    config.upperLimit.getDate(),
            month:   config.upperLimit.getMonth(),
            year:    config.upperLimit.getFullYear(),
            hour:   config.upperLimit.getHours(),
            minute: config.upperLimit.getMinutes()
        };
    }

    if (config.lowerLimit instanceof Date) {
        config.lowerLimit = {
            date:   config.lowerLimit.getDate(),
            month:  config.lowerLimit.getMonth(),
            year:   config.lowerLimit.getFullYear(),
            hour:  config.lowerLimit.getHours(),
            minute: config.lowerLimit.getMinutes()
        };
    }

    // Рабочие дни
    config.workDays = config.workDays.map(day => +day);

    // Время работы
    if (config.workTime) {
        config.workTime.interval      = Number(config.workTime.interval);
        config.workTime.start.hour    = Number(config.workTime.start.hour);
        config.workTime.start.minute  = Number(config.workTime.start.minute);
        config.workTime.finish.hour   = Number(config.workTime.finish.hour);
        config.workTime.finish.minute = Number(config.workTime.finish.minute);
    }
}

function _initLocale() {
    const { locale } = this.config;

    // Локализация
    const { month, month_d } = locale;

    this.config.locale = {
        ...locale,

        month: [
            month.january,
            month.february,
            month.march,
            month.april,
            month.may,
            month.june,
            month.july,
            month.august,
            month.september,
            month.october,
            month.november,
            month.december
        ],
        month_d: [
            month_d.january,
            month_d.february,
            month_d.march,
            month_d.april,
            month_d.may,
            month_d.june,
            month_d.july,
            month_d.august,
            month_d.september,
            month_d.october,
            month_d.november,
            month_d.december
        ]
    };
}

function _initMasks() {
    const { dateFormat } = this.config;

    const { dateLiteral, timeLiteral, dateTimeLiteral } = dateFormat;
    let { dateMask, timeMask } = dateFormat;

    // Приводим маску к требуемому нам виду (пока не поддерживаем leading zero и другие форматы)
    dateMask = dateMask.toUpperCase()
        .replace(/D+/, 'DD')
        .replace(/M+/, 'MM')
        .replace(/Y+/, 'YYYY');

    // Time is lower
    timeMask = timeMask.toLowerCase()
        .replace(/h+/, 'hh')
        .replace(/m+/, 'mm')
        .replace(/t+/, 'tt');

    if (dateFormat.hour12 && !/tt/.test(timeMask)) {
        timeMask += ' tt';
    }

    const dateTimeMask = `${ dateMask }${ dateTimeLiteral }${ timeMask }`;

    const dayPosition   = dateMask.search(/D/);
    const monthPosition = dateMask.search(/M/);
    const yearPosition  = dateMask.search(/Y/);

    // Маска даты не полная
    if (dayPosition === -1 || monthPosition === -1 || yearPosition === -1) {
        dateFormat.dateMask = `DD${ dateLiteral }MM${ dateLiteral }YYYY`;

        _initMasks();
        return;
    }

    const hourPosition   = dateTimeMask.search(/h/);
    const minutePosition = dateTimeMask.search(/m/);
    const ampmPosition   = dateTimeMask.search(/t/);

    // Маска даты не полная
    if (hourPosition === -1 || minutePosition === -1) {
        dateFormat.timeMask = `hh${ timeLiteral }mm`;

        _initMasks();
        return;
    }

    // Порядок
    const dateOrder = [
        {
            subject: 'date',
            position: dayPosition
        },
        {
            subject: 'month',
            position: monthPosition
        },
        {
            subject: 'year',
            position: yearPosition
        }
    ].sort((a, b) => a.position - b.position).filter(item => item.position >= 0);

    const timeOrder = [
        {
            subject: 'hour',
            position: hourPosition
        },
        {
            subject: 'minute',
            position: minutePosition
        },
        {
            subject: 'ampm',
            position: ampmPosition
        }
    ].sort((a, b) => a.position - b.position).filter(item => item.position >= 0);

    const dateTimeOrder = [
        {
            subject: 'date',
            position: dayPosition
        },
        {
            subject: 'month',
            position: monthPosition
        },
        {
            subject: 'year',
            position: yearPosition
        },
        {
            subject: 'hour',
            position: hourPosition
        },
        {
            subject: 'minute',
            position: minutePosition
        },
        {
            subject: 'ampm',
            position: ampmPosition
        }
    ].sort((a, b) => a.position - b.position).filter(item => item.position >= 0);

    this.masks = {
        dateTimeMask: {
            divider: dateTimeLiteral,
            mask: dateTimeMask,
            order: dateTimeOrder
        },

        dateMask: {
            divider: dateLiteral,
            mask: dateMask,
            order: dateOrder
        },

        timeMask: {
            divider: timeLiteral,
            mask: timeMask,
            order: timeOrder
        }
    };
}
